var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var driversDateFormat = function (drivers) {
    return drivers.map(function (driver) { return (__assign(__assign({}, driver), { hourRange: [
            new Date(driver.hourRange[0]),
            new Date(driver.hourRange[1])
        ] })); });
};
export var regenerateDriverValidityObj = function (drivers) { return drivers.reduce(function (prev, current) {
    var _a;
    return (__assign(__assign({}, prev), (_a = {}, _a[current.id.toString()] = true, _a)));
}, {}); };
export var allTrue = function (drivers) { return Object.values(drivers).every(function (obj) { return !!obj; }); };
export var someNotSaved = function (drivers) { return Object.values(drivers).some(function (valid) { return valid === 'not-saved'; }); };
//# sourceMappingURL=association-functions.js.map